/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API25060Item {
  
  /** 分类id */
  id?: number;
  
  /** 问题描述 */
  questionTypeDesc?: string;
  
};
    
  



  export type API25060Req = {};



export interface API25060Res {
  /** T  */
  list?: API25060Item[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 25060 获取所有的问题类型

export interface IUseGetAPI25060Return {
  /** 获取所有的问题类型: 接口请求状态 */
  isAPI25060Loading: boolean;
  /** 获取所有的问题类型: 接口请求返回数据 */
  dataAPI25060: API25060Res;
  /**  获取所有的问题类型: 接口数据请求方法 */
  fetchAPI25060Data:  ( config?: YWRequestConfig) => Promise<API25060Res>;
  /** 获取所有的问题类型: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI25060 = ():IUseGetAPI25060Return => {
  let isMount = true;
  const [isAPI25060Loading, setIsAPI25060Loading] = useState(false);
  const [dataAPI25060, setDataAPI25060] = useState<API25060Res>({} as API25060Res);
  const requestUrl = `${basePath}/ywwl-admin/question/feedback/type/list`;

  const fetchAPI25060Data = async ( config?: YWRequestConfig): Promise<API25060Res> => {
  
    if ( isMount ) {
      setIsAPI25060Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API25060Res>(`${basePath}/ywwl-admin/question/feedback/type/list`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI25060(res || {} as API25060Res);
        setIsAPI25060Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI25060Loading(false);
      }
      return false as unknown as API25060Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI25060Loading,
    dataAPI25060,
    fetchAPI25060Data,
    requestUrl,
  }
}

